export default __webpack_public_path__ + "static/media/Likewise-Banner-Vesta_Vinyl.03ab3118.jpg";